module.exports = __webpack_public_path__ + "static/media/pWINGS.dca9f9fe.png";